import React from "react";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import FileCategoryTable from "./view/FileCategoryTable";

interface FileCategoryProps {}
export const FileCategory: React.FC<FileCategoryProps> = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_securityconfiguration_filecategory_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <> {userPermissions.includes(viewPermission) && <FileCategoryTable />} </>
  );
};
export default FileCategory;
